var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<games-logo-upload game=\"vm.resource\" logo=\"vm.logo\"></games-logo-upload><formly-form model=\"vm.resource\" fields=\"vm.fields\"></formly-form>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/games/gamesForm.jade
 ** module id = 832
 ** module chunks = 0
 **/